<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {
  },
}
</script>

<style lang="scss">
html * {
    margin:0;
    padding: 0;
    font-family: a-otf-gothic-bbb-pr6n, sans-serif;
    font-weight: 400;
    font-style: normal;
  }
a {
  text-decoration: none;
}
div,img {
    margin:0;
    padding: 0;
}
#app {
  // -webkit-font-smoothing: antialiased;
  // -moz-osx-font-smoothing: grayscale;
  line-height: 2em;
}
.font__roboto {
  font-family: neue-haas-grotesk-display, sans-serif;
  font-weight: 500;
  font-style: normal;
  letter-spacing: 0.5px;
}
.font__caption {
  font-family: a-otf-midashi-go-mb31-pr6n, sans-serif;
  font-weight: 600;
  font-style: normal;
}
.text__area__style__line__feed {
  // 改行コードで改行する
  white-space: pre-wrap;
}
.text__area__style__align__both__ends {
  // 文字の両端ぞろえ
  text-align: justify;
  text-justify: inter-ideograph;
}
ul {
    line-height: normal;
    list-style: none;
}
</style>
